import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { StyledRadioButtons } from '../../../../Components/Generics.styled';
import styled from 'styled-components';
import { StyledButton } from '../../../../Components/Generics.styled';

const DoYouHaveStoreContainer = styled.div`
    /* border: 1px solid red; */
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    /* border: 1px solid red; */
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: 360px;
    border: 1px solid white;
`;

const DoYouHaveStore = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { doYouHaveStore } = { ...teachDavieData };
    const [value, setValue] = useState('');

    useEffect(() => {
        if (doYouHaveStore !== '') {
            setValue(doYouHaveStore);
        }
    }, [doYouHaveStore]);

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, doYouHaveStore: value }));
        handleNavButtonNext();
    };

    const options = [
        {
            value: 'yes',
            label: 'Yes',
        },
        {
            value: 'no',
            label: 'No',
        },
    ];

    return (
        <DoYouHaveStoreContainer>
            <StyledRadioButtons
                label={'Do you have a store or office where you meet customers?'}
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                options={options}
            />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNavButtonBack()}>Previous</Btn>
                <Btn onClick={() => handleNext()}>Next</Btn>
            </NavButtonContainer>
        </DoYouHaveStoreContainer>
    );
};

DoYouHaveStore.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

DoYouHaveStore.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default DoYouHaveStore;
